module.exports = __webpack_public_path__ + "img/gallery-14.b6047a4d.jpg";